// OpenNotification.web.tsx
// Customizable Area Start
import React from "react";
import {
  Container,
  Box,
  Typography,
  Avatar,
  IconButton,
  Paper,
  TextField,
  Snackbar,
  Popover,
  Modal,
  withWidth, isWidthUp,
  FormControlLabel,
  Switch
} from "@material-ui/core";
import { createStyles, styled, Theme, withStyles } from "@material-ui/core/styles";
import { IconAvtar, womanImage } from "../../contactlist/src/assets";
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import FavoriteBorderRoundedIcon from '@material-ui/icons/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@material-ui/icons/FavoriteRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { MoreHorizRounded } from "@material-ui/icons";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import MuiAlert from "@material-ui/lab/Alert";
import OpenNotificationController, {
  Props,
  CommentOrderEnum
} from "./OpenNotificationController.web";
import { everyBrandLogo } from "../../postcreation/src/assets";
import { RedLikeIcon, sendIcon, whiteCommentIcon, UploadIcon } from "./assets";
import MediaComponent from "../../../components/src/MediaComponent.web"; // <-- updated component
import DescriptionComponent from "../../../components/src/ReadMoreDescription.web";
import CustomLoader from "../../../components/src/CustomLoader.web";
import clsx from "clsx"
import CommentImage from "../../../components/src/CommentImage.web";
import Poll from "../../dashboard/src/Poll.web";
const helper = require("../../../components/src/helper.js")

export default class OpenNotification extends OpenNotificationController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  render() {
    // Customizable Area Start
    const { classes } = this.props;
    const isMobile = this.props.width ? !isWidthUp('md', this.props.width) : window.innerWidth < 960;
    const {
      isLoading,
      postData,
      isShowAlert,
      showSuccess,
      repliesOpenCommentId,
      isAddingComment,
      commentsOrder,
      isSortingComments,
      postComments,
      infoType,
      replyingToName,
      comment,
      commentImage,
      commentOptionsModal,
      commentOptionsAnchorEl,
      pollCommentModal,
      pollQuestion,
      pollOptions,
      allowMultipleResponses,
      selectedVideoFile,
      videoCommentModal,
      replyingToId
    } = this.state

    if (isLoading || !postData) {
      return (
        <CustomLoader loaderSize={28} wrapperHeight="70vh" isLoading={isLoading} />
      )
    }

    return (
      <Container
        disableGutters
        maxWidth={false}
        className={classes.mainNotificationContainer}
      >
        <Snackbar
          open={isShowAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert elevation={6} variant="filled" severity={infoType}>
            {showSuccess}
          </MuiAlert>
        </Snackbar>
        <Box className={classes.postHeadingWrapper}>
          <IconButton
            data-test-id="backIcon"
            onClick={() => this.handleRedirection("Notifications")}
          >
            <ArrowBackIosRoundedIcon />
          </IconButton>
          <div className={classes.postAvatar}>
            <Avatar className={classes.activeUserAvatar}>
              <img
                src={this.ternary(
                  postData?.attributes?.account_profile,
                  postData?.attributes?.account_profile?.url,
                  IconAvtar
                )}
                alt="User Profile"
                className={classes.fallbackAvatar}
              />
            </Avatar>
            <div>
              <Typography className={classes.name}>
                {`${postData?.attributes.account?.first_name} ${postData?.attributes?.account.last_name}`}
              </Typography>
              <Typography className={classes.contactInfoNumber}>
                {postData.attributes.created_at}
              </Typography>
            </div>
          </div>
        </Box>
        <Box className={classes.postWrapper}>
          <Box className={classes.previewContainer}>
            <Box className={classes.imagePreviewContainer}>
              <MediaComponent
                url={Array.isArray(postData.attributes.files) ? postData.attributes.files[0].link : womanImage}
              />
            </Box>
            <Box className={classes.previewTopOverlay}>
              <Box className={classes.overlayBottom}>
                <Box className={classes.postInfoContainer}>
                  <Box className={classes.postTitleAndCaption}>
                    <Typography className={classes.postOverlayTitle}>
                      Necronomicon ART
                    </Typography>
                    <Typography className={classes.postOverlayTitle}>
                      {postData.attributes.account.first_name +
                        " " +
                        postData.attributes.account.last_name}
                    </Typography>
                    <DescriptionComponent
                      data-test-id="post-description"
                      description={postData.attributes.description}
                    />
                  </Box>
                  <Box className={classes.postSocialStats}>
                    <Box className={classes.avatarContainer}>
                      <img
                        src={this.ternary(
                          postData?.attributes?.account_profile,
                          postData?.attributes?.account_profile?.url,
                          IconAvtar
                        )}
                        alt="avatar"
                        className={classes.avatar}
                      />
                    </Box>
                    <Box className={classes.socialStatsContainer}>
                      <IconButton
                        data-test-id="post-like-button"
                        size="small"
                        onClick={this.handlePostLikeUnlike}
                      >
                        {this.ternary(
                          postData.attributes.is_liked,
                          <FavoriteRoundedIcon className={classes.postLikedImage} />,
                          <FavoriteBorderRoundedIcon className={classes.likesIcon} />
                        )}
                      </IconButton>
                      <Typography className={classes.countsFonts}>
                        {postData.attributes.likes_count}
                      </Typography>
                    </Box>
                    <Box className={classes.socialStatsContainer}>
                      <img
                        src={whiteCommentIcon}
                        alt="comments"
                        className={classes.commentsIcon}
                      />
                      <Typography className={classes.countsFonts}>
                        {postData.attributes.comments_count}
                      </Typography>
                    </Box>
                    <Box className={classes.socialStatsContainer}>
                      <MoreHorizRounded />
                    </Box>
                  </Box>
                </Box>
                <Box className={classes.everybrandLogoContainer}>
                  <Typography className={classes.everybrandText}>
                    Powered by
                  </Typography>
                  <img src={everyBrandLogo} alt="Everybrand" />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.commentsContainer}>
          <div data-test-id="all-comments" title="Show all comments" onClick={this.showAllComments}>
            <Typography>All comments</Typography>
          </div>
          <IconButton
            size="small"
            title="Sort"
            data-test-id="sort-button"
            disabled={isSortingComments}
            className={clsx({
              [classes.expandedArrow]: commentsOrder === CommentOrderEnum.DESCENDING,
            })}
            onClick={this.toggleCommentSortChange}
          >
            <ExpandMoreRoundedIcon />
          </IconButton>
        </Box>
        <Box className={classes.commentListWrapper}>
          <CustomLoader
            wrapperHeight="70vh"
            loaderSize={22}
            isLoading={isSortingComments}
          >
            {/* <Box className={classes.pollContainer}>
            <Poll 
              poll={postData.attributes.poll} 
              poll_options={postData.attributes.poll_options}
              accountProfile={postData?.attributes?.account_profile?.url} 
              handleVote={(optionId : number) => this.handlePollVoteNotification(optionId, postData.id)}
              handleDeleteVote={(optionId : number) => this.handlePollDeleteNotification(optionId, postData.id)}
            />
            </Box> */}
            <div
              ref={this.commentsWrapperRef}
              className={classes.commentsScrollableWrapper}
            >
              {postComments.length > 0 &&
                postComments.map((commentDetails) => {
                  const {
                    id,
                    attributes: {
                      already_liked,
                      created_at,
                      account,
                      comment,
                      replies,
                      files,
                      comment_poll,
                      comment_poll_options
                    },
                  } = commentDetails;
                  const {
                    data: {
                      attributes: { first_name, last_name, profile_pic },
                    },
                  } = account;
                  const isRepliesExist = replies.data.length > 0;
                  const isRepliesExpanded = repliesOpenCommentId === id;
                  // Handle both comment_poll and poll (if API returns either)
                  const commentPoll = comment_poll || (commentDetails.attributes as any).poll;
                  const commentPollOptions = comment_poll_options || (commentDetails.attributes as any).poll_options || [];
      
                  return (
                    <ReceiverMessageContainer key={id} id={`comment-${id}`}>
                      <Box id="commentAvtarBox">
                        <Avatar
                          className={classes.activeUserAvatar}
                          data-test-id="commentAvtarBox"
                        >
                          <img
                            src={this.orCondition(profile_pic?.url, IconAvtar)}
                            alt="profilepic"
                            className={classes.fallbackAvatar}
                          />
                        </Avatar>
                      </Box>
                      <Box flex={1} maxWidth="650px">
                        <MessageBubble highlight={this.isToHighlight(id)}>
                          <div className={classes.messageDetailsWrapper}>
                            <div className="commenterNAme">
                              <Typography className={classes.commentUsername}>
                                {`${first_name} ${last_name}`}
                              </Typography>
                            </div>
                            <div className="commenterTime">
                              <Typography className={classes.commentText}>
                                {helper.timeSince(created_at)}
                              </Typography>
                            </div>
                          </div>
                          <Typography className={classes.comment} data-test-id="comment-text">
                            {commentPoll 
                              ? commentPoll.question ?? "" 
                              : (comment === "Poll" ? "" : comment)
                            }
                          </Typography>
                          <CommentImage files={files} />
                          {commentPoll && (
                            <Box style={{ marginTop: "12px", padding: "12px 0",alignItems: "flex-start"}}>
                              <Poll
                                hideLabel={true}
                                poll={{
                                  id: commentPoll.id,
                                  question: commentPoll.question,
                                  comment_id: parseInt(id),
                                  post_id: commentDetails.attributes.commentable_id,
                                  created_at: commentPoll.created_at,
                                  user_voted_option_id: commentPoll.user_voted_option_id,
                                  total_count: commentPoll.total_count
                                }}
                                poll_options={commentPollOptions}
                                accountProfile={profile_pic?.url}
                                handleVote={(optionId: number) => {
                                  return this.handleCommentPollVote(optionId, id);
                                }}
                                handleDeleteVote={(optionId: number) => {
                                  return this.handleCommentPollDeleteVote(optionId, id);
                                }}
                              />
                            </Box>
                          )}
                        </MessageBubble>
                        <Box className={classes.commentActionsWrapper}>
                          <button
                            data-test-id="comment-reply-button"
                            className={classes.replyButton}
                            onClick={() => this.handleReplyClick(commentDetails)}
                          >
                            Reply
                          </button>
                          {isRepliesExist && (
                            <Box className={classes.replyExpandWrapper}>
                              <Typography>
                                {this.getReplyText(replies.data.length)}
                              </Typography>
                              <IconButton
                                data-test-id="reply-toggle"
                                size="small"
                                className={clsx({
                                  [classes.expandedArrow]: isRepliesExpanded,
                                })}
                                onClick={() => this.toggleReplies(id)}
                              >
                                <ExpandMoreRoundedIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          )}
                        </Box>
                        {isRepliesExpanded && (
                          <Box>
                            {replies.data.map((replyData) => {
                              const {
                                id,
                                attributes: {
                                  account,
                                  already_liked,
                                  created_at,
                                  comment,
                                  files,
                                  comment_poll,
                                  comment_poll_options
                                },
                              } = replyData;
                              const {
                                data: {
                                  attributes: { first_name, last_name, profile_pic },
                                },
                              } = account;
                              // Handle both comment_poll and poll (if API returns either)
                              const replyPoll = comment_poll || (replyData.attributes as any).poll;
                              const replyPollOptions = comment_poll_options || (replyData.attributes as any).poll_options || [];
      
                              return (
                                <ReceiverMessageContainer key={id} id={`Reply ${id}`}>
                                  <Box id="commentAvtarBox">
                                    <Avatar
                                      className={classes.activeUserAvatar}
                                      data-test-id="commentAvtarBox"
                                    >
                                      <img
                                        src={this.orCondition(
                                          profile_pic?.url,
                                          IconAvtar
                                        )}
                                        alt="profilepic"
                                        className={classes.fallbackAvatar}
                                      />
                                    </Avatar>
                                  </Box>
                                  <Box flex={1} maxWidth="650px">
                                    <MessageBubble highlight={this.isToHighlight(id)}>
                                      <div className={classes.messageDetailsWrapper}>
                                        <div className="commenterNAme">
                                          <Typography
                                            className={classes.commentUsername}
                                          >
                                            {`${first_name} ${last_name}`}
                                          </Typography>
                                        </div>
                                        <div className="commenterTime">
                                          <Typography className={classes.commentText}>
                                            {helper.timeSince(created_at)}
                                          </Typography>
                                        </div>
                                      </div>
                                      <Typography className={classes.comment} data-test-id="comment-reply">
                                        {replyPoll 
                                          ? replyPoll.question ?? "" 
                                          : (comment === "Poll" ? "" : comment)
                                        }
                                      </Typography>
                                      <CommentImage files={files} />
                                      {replyPoll && (
                                        <Box style={{ marginTop: "12px", padding: "12px 0",alignItems: "flex-start"}}>
                                          <Poll
                                            hideLabel={true}
                                            poll={{
                                              id: replyPoll.id,
                                              question: replyPoll.question,
                                              comment_id: parseInt(id),
                                              post_id: replyData.attributes.commentable_id,
                                              created_at: replyPoll.created_at,
                                              user_voted_option_id: replyPoll.user_voted_option_id,
                                              total_count: replyPoll.total_count
                                            }}
                                            poll_options={replyPollOptions}
                                            accountProfile={profile_pic?.url}
                                            handleVote={(optionId: number) => {
                                              return this.handleCommentPollVote(optionId, id);
                                            }}
                                            handleDeleteVote={(optionId: number) => {
                                              return this.handleCommentPollDeleteVote(optionId, id);
                                            }}
                                          />
                                        </Box>
                                      )}
                                    </MessageBubble>
                                    <Box className={classes.commentActionsWrapper}>
                                      <button
                                        data-test-id="reply-reply-button"
                                        className={classes.replyButton}
                                        onClick={() =>
                                          this.handleReplyClick(
                                            replyData,
                                            commentDetails.id
                                          )
                                        }
                                      >
                                        Reply
                                      </button>
                                    </Box>
                                  </Box>
                                  <IconButton
                                    className={classes.likeButton}
                                    data-test-id="comment-reply-like-toggle"
                                    onClick={() =>
                                      this.handleCommentReplyLikeUnlike(
                                        commentDetails.id,
                                        id,
                                        already_liked
                                      )
                                    }
                                  >
                                    {this.ternary(
                                      already_liked,
                                      <img
                                        src={RedLikeIcon}
                                        alt="Undo like"
                                        className={classes.likedImage}
                                      />,
                                      <FavoriteBorderIcon />
                                    )}
                                  </IconButton>
                                </ReceiverMessageContainer>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                      <IconButton
                        data-test-id="comment-like-toggle"
                        className={classes.likeButton}
                        onClick={() =>
                          this.handleCommentLikeUnlike(id, already_liked)
                        }
                      >
                        {already_liked ? (
                          <img
                            src={RedLikeIcon}
                            alt="Undo like"
                            className={classes.likedImage}
                          />
                        ) : (
                          <FavoriteBorderIcon />
                        )}
                      </IconButton>
                    </ReceiverMessageContainer>
                  );
                })}
            </div>
          </CustomLoader>
          <Box className={classes.addCommentWrapper}>
            <Box className={classes.addCommentInnerWrapper}>
              <Box className={classes.iconButtonWrapper}>
                <IconButton
                  size="small"
                  className={classes.iconButtonWrapper}
                  data-test-id="comment-image-button"
                  onClick={this.handleImageCommentClick}
                >
                  <img src={UploadIcon} alt="Image upload" />
                </IconButton>
                <input
                  hidden
                  type="file"
                  data-test-id="comment-image-input"
                  accept=".jpeg, .jpg, .png"
                  ref={this.imageCommentFieldRef}
                  onChange={this.handleImageCommentUpload}
                />
                <input
                  ref={this.videoCommentRef}
                  accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
                  type="file"
                  hidden
                  data-test-id="video-comment-file"
                  capture={isMobile ? "environment" : undefined}
                  onChange={this.handleVideoCommentUpload}
                />
              </Box>
              <Box flex={1}>
                {commentImage && (
                  <Box margin={1}>
                    <Box className={classes.commentImagePreviewWrapper}>
                      <IconButton
                        size="small"
                        data-test-id="image-comment-remove"
                        onClick={this.handleImageCommentRemove}
                      >
                        <CloseRoundedIcon fontSize="small" />
                      </IconButton>
                      <img
                        src={URL.createObjectURL(commentImage)}
                        alt="Image"
                        data-test-id="comment-image-selected"
                        className={classes.commentImagePreview}
                      />
                    </Box>
                  </Box>
                )}
                <TextField
                  data-test-id="innerReplyCommentsField"
                  placeholder={this.getFieldPlaceholder()}
                  variant="outlined"
                  inputRef={this.commentFieldRef}
                  onChange={(e) => this.setState({ comment: e.target.value })}
                  fullWidth
                  multiline
                  maxRows={2}
                  value={this.state.comment}
                  name="replyComment"
                  InputProps={{
                    classes: {
                      root: classes.postReplyField,
                      input: classes.postReplyInput,
                    },
                  }}
                />
              </Box>
              
              <IconButton
                size="small"
                className={classes.iconButtonWrapper}
                disabled={isAddingComment || (!this.state.comment && !this.state.commentImage)}
                data-test-id="postCommentApiCall"
                onClick={this.handlePostComment}
              >
                <img src={sendIcon} alt="Send" />
              </IconButton>

            </Box>
          </Box>
        </Box>
        {/* Comment Options Modal - Use Modal on mobile, Popover on desktop */}
        {isMobile ? (
          <Modal
            open={commentOptionsModal}
            onClose={this.handleCloseCommentOptionsModal}
            aria-labelledby="comment-options-modal-title"
            aria-describedby="comment-options-modal-description"
            data-test-id="commentOptionsModal"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box className={classes.commentOptionsModalBox} style={{
              position: 'relative',
              outline: 'none',
              maxWidth: '90%',
              width: '280px',
            }}>
              <IconButton
                onClick={this.handleCloseCommentOptionsModal}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '8px',
                  padding: '4px',
                }}
              >
                <CloseRoundedIcon />
              </IconButton>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  padding: '8px 0',
                }}
              >
                <Box
                  component="button"
                  onClick={this.handleUploadVideoComment}
                  onTouchEnd={(e) => {
                    e.preventDefault()
                    this.handleUploadVideoComment(e)
                  }}
                  className={classes.uploadVideoCommentButton}
                  data-test-id="upload-video-comment-button"
                >
                  {replyingToId ? 'Upload Video Reply' : 'Upload Video Comment'}
                </Box>
                {!replyingToId && (
                  <Box
                    component="button"
                    onClick={this.handleAddPollComment}
                    onTouchEnd={(e) => {
                      e.preventDefault()
                      this.handleAddPollComment(e)
                    }}
                    className={classes.addPollCommentButton}
                    data-test-id="add-poll-comment-button"
                  >
                    Add Poll Comment
                  </Box>
                )}
              </Box>
            </Box>
          </Modal>
        ) : (
          <Popover
            open={commentOptionsModal}
            anchorEl={commentOptionsAnchorEl}
            onClose={this.handleCloseCommentOptionsModal}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            style={{
              marginBottom: '20px',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            data-test-id="commentOptionsModal"
          >
            <Box className={classes.commentOptionsModalBox}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  padding: '8px 0',
                }}
              >
                <Box
                  component="button"
                  onClick={this.handleUploadVideoComment}
                  onTouchEnd={(e) => {
                    e.preventDefault()
                    this.handleUploadVideoComment(e)
                  }}
                  className={classes.uploadVideoCommentButton}
                  data-test-id="upload-video-comment-button"
                >
                  {replyingToId ? 'Upload Video Reply' : 'Upload Video Comment'}
                </Box>
                {!replyingToId && (
                  <Box
                    component="button"
                    onClick={this.handleAddPollComment}
                    onTouchEnd={(e) => {
                      e.preventDefault()
                      this.handleAddPollComment(e)
                    }}
                    className={classes.addPollCommentButton}
                    data-test-id="add-poll-comment-button"
                  >
                    Add Poll Comment mobile
                  </Box>
                )}
              </Box>
            </Box>
          </Popover>
        )}
        {/* Poll Comment Modal */}
        <Modal
          open={pollCommentModal}
          onClose={this.handleClosePollCommentModal}
          aria-labelledby="poll-comment-modal-title"
          aria-describedby="poll-comment-modal-description"
          data-test-id="pollCommentModal"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
          disableEnforceFocus={false}
          disableAutoFocus={false}
          BackdropProps={{
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1299,
            },
            onClick: this.handleClosePollCommentModal,
          }}
        >
          <Box
            className={classes.pollCommentModalBox}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            style={{
              zIndex: 1300,
              position: 'relative',
              ...(isMobile && {
                maxWidth: '90%',
                maxHeight: '85vh',
                margin: '20px',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
              }),
            }}
          >
            {/* Header */}
            <Box className={classes.pollCommentModalHeader}>
              <Typography className={classes.pollCommentModalTitle}>
                Make a Poll Comment
              </Typography>
              <IconButton
                onClick={this.handleClosePollCommentModal}
                className={classes.pollCommentModalCloseButton}
                data-test-id="close-poll-comment-modal"
              >
                <CloseRoundedIcon />
              </IconButton>
            </Box>

            {/* Question Section */}
            <Box className={classes.pollCommentModalSection}>
              <Typography className={classes.pollCommentModalLabel}>
                Question
              </Typography>
              <TextField
                placeholder="Make a question"
                value={pollQuestion}
                onChange={(e) => this.setState({ pollQuestion: e.target.value })}
                variant="outlined"
                fullWidth
                className={classes.pollCommentModalInput}
                data-test-id="poll-question-input"
                autoFocus={!isMobile}
                inputProps={{
                  style: {
                    WebkitAppearance: 'none',
                    WebkitUserSelect: 'text',
                    userSelect: 'text',
                  },
                }}
                onFocus={(e) => {
                  if (isMobile) {
                    // Ensure input is visible on mobile when keyboard opens
                    setTimeout(() => {
                      e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 300);
                  }
                }}
              />
            </Box>

            {/* Options Section */}
            <Box className={classes.pollCommentModalSection}>
              <Typography className={classes.pollCommentModalLabel}>
                Options
              </Typography>
              {pollOptions.map((option, index) => (
                <Box key={index} style={{ marginBottom: '12px' }}>
                  <TextField
                    placeholder="Add an Option"
                    value={option}
                    onChange={(e) => this.handlePollOptionChange(index, e.target.value)}
                    variant="outlined"
                    fullWidth
                    className={classes.pollCommentModalInput}
                    data-test-id={`poll-option-input-${index}`}
                    inputProps={{
                      style: {
                        WebkitAppearance: 'none',
                        WebkitUserSelect: 'text',
                        userSelect: 'text',
                      },
                    }}
                    onFocus={(e) => {
                      if (isMobile) {
                        // Ensure input is visible on mobile when keyboard opens
                        setTimeout(() => {
                          e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }, 300);
                      }
                    }}
                  />
                </Box>
              ))}
            </Box>

            {/* Allow Multiple Responses Toggle */}
            <Box className={classes.pollCommentModalSection}>
              <FormControlLabel
                control={
                  <Switch
                    checked={allowMultipleResponses}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ allowMultipleResponses: e.target.checked })}
                    className={classes.pollCommentSwitch}
                    data-test-id="allow-multiple-responses-switch"
                  />
                }
                label="Allow Multiple responses"
                className={classes.pollCommentToggleLabel}
              />
            </Box>

            {/* Continue Button */}
            <Box className={classes.pollCommentModalFooter}>
              <Box
                component="button"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  this.handlePollContinue(e)
                }}
                onTouchEnd={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  this.handlePollContinue(e)
                }}
                className={classes.pollCommentContinueButton}
                data-test-id="poll-comment-continue-button"
              >
                Continue
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* Video Comment Upload Modal */}
        <Modal
          open={videoCommentModal}
          onClose={this.handleCloseVideoCommentModal}
          aria-labelledby="video-comment-modal-title"
          aria-describedby="video-comment-modal-description"
          data-test-id="videoCommentModal"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
          disableEnforceFocus={false}
          disableAutoFocus={false}
          BackdropProps={{
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1299,
            },
            onClick: this.handleCloseVideoCommentModal,
          }}
        >
          <Box
            className={classes.pollCommentModalBox}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            style={{
              zIndex: 1300,
              position: 'relative',
              ...(isMobile && {
                maxWidth: '90%',
                maxHeight: '85vh',
                margin: '20px',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
              }),
            }}
          >
            {/* Header */}
            <Box className={classes.pollCommentModalHeader}>
              <Typography className={classes.pollCommentModalTitle}>
                {replyingToId ? 'Upload Video Reply' : 'Upload Video Comment'}
              </Typography>
              <IconButton
                onClick={this.handleCloseVideoCommentModal}
                className={classes.pollCommentModalCloseButton}
                data-test-id="close-video-comment-modal"
              >
                <CloseRoundedIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box className={classes.pollCommentModalSection}>
              {!selectedVideoFile ? (
                <>
                  <Typography className={classes.pollCommentModalLabel} style={{ marginBottom: '16px' }}>
                    Select a video file to upload as a comment
                  </Typography>
                  <Box
                    component="button"
                    onClick={this.handleSelectVideo}
                    className={classes.uploadVideoCommentButton}
                    data-test-id="select-video-button"
                  >
                    Select Video
                  </Box>
                </>
              ) : (
                <>
                  <Typography className={classes.pollCommentModalLabel} style={{ marginBottom: '16px' }}>
                    Selected Video
                  </Typography>
                  <Box style={{
                    padding: '12px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '8px',
                    marginBottom: '16px'
                  }}>
                    <Typography style={{
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      color: '#1f2937',
                      wordBreak: 'break-word'
                    }}>
                      {selectedVideoFile.name}
                    </Typography>
                    <Typography style={{
                      fontFamily: 'Inter',
                      fontSize: '12px',
                      color: '#6b7280',
                      marginTop: '4px'
                    }}>
                      {(selectedVideoFile.size / (1024 * 1024)).toFixed(2)} MB
                    </Typography>
                  </Box>
                  <Box
                    component="button"
                    onClick={this.handleSelectVideo}
                    className={classes.addPollCommentButton}
                    data-test-id="change-video-button"
                    style={{ marginBottom: '12px' }}
                  >
                    Change Video
                  </Box>
                  <Box style={{ marginTop: '16px' }}>
                    <TextField
                      data-test-id="video-comment-text-field"
                      placeholder={replyingToId ? `Replying to ${replyingToName}` : "Add a comment"}
                      variant="outlined"
                      value={comment}
                      fullWidth
                      multiline
                      maxRows={4}
                      minRows={2}
                      name="videoComment"
                      onChange={(e) => this.setState({ comment: e.target.value })}
                      InputProps={{
                        classes: {
                          root: classes.postCommentTextField,
                          input: classes.postCommentinput,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.placeholder,
                        },
                      }}
                    />
                  </Box>
                </>
              )}
            </Box>

            {/* Footer */}
            {selectedVideoFile && (
              <Box className={classes.pollCommentModalFooter}>
                <Box
                  component="button"
                  onClick={this.handleConfirmVideoUpload}
                  className={classes.uploadVideoCommentButton}
                  data-test-id="confirm-video-upload-button"
                >
                  Upload Video
                </Box>
              </Box>
            )}

            {/* Hidden input elements */}
            <input
              ref={this.videoModalInputRef}
              accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
              type="file"
              hidden
              data-test-id="video-comment-modal-file"
              onChange={this.handleVideoCommentUpload}
            />
            <input
              ref={this.videoGalleryInputRef}
              accept="video/*,.mp4,.mpeg,.mov,.avi,.mkv,.webm,.3gp,.flv"
              type="file"
              hidden
              data-test-id="video-comment-gallery-file"
              capture={false}
              onChange={this.handleVideoCommentUpload}
            />
            <input
              ref={this.videoCameraInputRef}
              accept="video/*"
              type="file"
              hidden
              data-test-id="video-comment-camera-file"
              capture="environment"
              onChange={this.handleVideoCommentUpload}
            />
          </Box>
        </Modal>
      </Container>
    );
    // Customizable Area End
  }
}

// Customizable Area Start

const ReceiverMessageContainer = styled("div")(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  padding: "10px",
  marginRight: "auto",
  gap: "8px",
  marginTop: "10px",
  [theme.breakpoints.down(650)]: {
    padding: "0px"
  },
}));

const MessageBubble = styled(Paper)(({theme,  highlight }: { theme: Theme, highlight?: boolean }) => ({
  padding: "12px 16px",
  boxShadow: "none",
  borderRadius: "0px 16px 16px 16px",
  backgroundColor: highlight ? "#fff2d2" : "#F1F5F9",
  "& > div": {
    display: "flex",
    gap: "4px",
    alignItems: "baseline",
    justifyContent: "space-between"
  },
  [theme.breakpoints.down(650)]: {
    padding: "8px"
  },
}));


export const styles: any = (theme: Theme) =>
  createStyles({
    previewTopOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      background: "rgba(0,0,0,0.3)", // ✅ subtle overlay
      color: "#fff",
      padding: "12px",
      transition: "background 0.3s ease-in-out",
      "&:hover": {
        background: "rgba(0,0,0,0.5)",
      },
    },
    overlayBottom: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    postInfoContainer: {
      display: "flex",
      gap: "15px",
      padding: "0px 25px 10px",
      justifyContent: "space-between",
    },
    postTitleAndCaption: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      justifyContent: "flex-end",
    },

    socialStatsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "#FFF",

    },

    likesIcon: {
      color: "#fff"
    },

    commentsIcon: {
      width: "33px",
      height: "30px",
      fill: "#FFF",
    },
    countsFonts: {
      fontSize: "14px",
      fontWeight: 400,
      color: "#FFF",
      fontFamily: "Inter",
      fontStyle: "normal"
    },
    everybrandLogoContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "8px",
      fontWeight: 700,
      color: "#FFF",
    },
    everybrandText: {
      paddingTop: "3px",
      fontSize: "8px",
      fontWeight: 700,
      fontFamily: "Inter",
      fontStyle: "normal"
    },
    postOverlayTitle: {
      fontSize: "15px",
      fontWeight: 700,
      color: "#FFF",
      fontFamily: "Inter",
      fontStyle: "normal"
    },
    postSocialStats: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    avatarContainer: {
      width: "35px",
      height: "35px",
      borderRadius: "50%",
      overflow: "hidden",
    },
    avatar: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    postReplyField: {
      borderRadius: "50px",
      background: "#F1F5F9",
      padding: "16px 12px"
    },
    postReplyInput: {
      '&::placeholder': {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: 400,
        fontStyle: "normal",
        color: '#64748B',
      }
    },
    commentsContainer: {
      marginTop: "39px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      width: "100%",
      "& p": {
        fontStyle: "normal",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 700
      },
      "& > button": {
        padding: "0px",
        transition: "transform 0.2s"
      },
      "& > div:first-child": {
        cursor: "pointer",
        padding: "3px 8px",
        borderRadius: "12px",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.04)"
        }
      },
    },
    commentListWrapper: {
      flex: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      backgroundColor: "white",
    },
    
    commentsScrollableWrapper: {
      flex: 1,
      width: "100%",
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
      boxSizing: "border-box",
      paddingBottom: "120px", 

      "@media (max-width: 600px)": {
        maxHeight: "65vh",
        overflowY: "auto",
        // paddingBottom: '140px',
      },
    },
    
    addCommentWrapper: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center",
      width: "100%",
      padding: "6px 8px 8px",
      backgroundColor: "#fff",
      zIndex: 1,
    
      "@media (min-width: 1150px)": {
        maxWidth: "900px",
        margin: "0 auto",
        left: "50%",
        transform: "translateX(-50%)",
      },
      [theme.breakpoints.down(650)]: {
        maxWidth: "900px",
        margin: "0 auto",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: 64,
      },
    },
    
    
    
    addCommentInnerWrapper: {
      display: "flex",
      alignItems: "flex-end",
      gap: "8px",
    
      width: "100%",
      maxWidth: "900px",
      padding: "0 10px",
    
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
      },
    },
    
    mainNotificationContainer: {
      flexDirection: "column",
      backgroundColor: "#FFF",
      justifyContent: "flex-start",
      display: "flex",
      padding: "20px 30px",
      overflow: "hidden",
      // height: "100vh",
      "@media (max-width: 1149px)": {
        padding: "15px 20px",
      },
      [theme.breakpoints.down("sm")]: {
        padding: "10px 15px",
      },
    },
    postHeadingWrapper: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    },
    activeUserAvatar: {
      color: "black",
      width: "44px",
      height: "44px",
      border: '2px solid #F0E5FF',
      backgroundColor: '#FFFFFF',
      [theme.breakpoints.down(650)]: {
        width: "36px",
        height: "36px",
      },
    },
    fallbackAvatar: {
      width: '44px',
      height: '44px',
      objectFit: 'cover',
      [theme.breakpoints.down(650)]: {
        width: "36px",
        height: "36px",
      },
    },
    postAvatar: {
      display: "flex",
      gap: "13.5px",
      alignItems: "center",
      "& > div:nth-child(1)": {
        marginBottom: "0px"
      }
    },
    name: {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "22px"
    },
    contactInfoNumber: {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "22px",
    },
    postWrapper: {
      marginTop: "20px",
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap", // ✅ allows wrapping for smaller screens
      gap: "16px",
      borderRadius: "8px",
      overflow: "hidden",
    },
    previewContainer: {
      position: "relative",
      flex: "1 1 23%",
      minWidth: "280px",
      maxWidth: "380px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    
      [theme.breakpoints.down(1200)]: {
        flex: "1 1 30%",
      },
      [theme.breakpoints.down(950)]: {
        flex: "1 1 45%",
      },
      [theme.breakpoints.down(650)]: {
        flex: "1 1 90%",
        maxWidth: "100%",
      },
    },
    imagePreviewContainer: {
      position: "relative",
      width: "100%",
      overflow: "hidden",
      background: "#F2F2F2",
      borderRadius: "12px",
      aspectRatio: "9 / 16", // ✅ Portrait frame (9:16)
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    
      "& img, & video": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "12px",
      },
    
      [theme.breakpoints.down(650)]: {
        aspectRatio: "9 / 16", // stays consistent on mobile too
      },
    },
    
    
    messageDetailsWrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    commentUsername: {
      fontWeight: 600,
      [theme.breakpoints.down(650)]: {
        fontSize: "12px"
      },
    },
    commentText: {
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "Inter",
      fontStyle: "normal",
      color: "#64748B",
      [theme.breakpoints.down(650)]: {
        fontSize: "10px"
      },
    },
    comment: {
      wordBreak: "break-word",
      whiteSpace: "pre-line",
      [theme.breakpoints.down(650)]: {
        fontSize: "14px"
      },
    },
    likeButton: {
      alignSelf: "flex-start",
      marginTop: "14px"
    },
    likedImage: {
      width: "24px",
      height: "24px",
      border: "2px solid transparent"
    },
    postLikedImage: {
      color: "#FF0000"
    },
    commentActionsWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginLeft: "10px",
    },
    replyButton: {
      color: "#64748B",
      fontSize: "13px",
      fontStyle: "normal",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: "normal",
      border: "none",
      backgroundColor: "transparent"
    },
    replyExpandWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "3px",
      marginTop: "2px",
      "& > p": {
        color: "#64748B",
        fontSize: "11px",
        fontFamily: "Inter",
        fontWeight: 500
      },
      "& > button": {
        padding: "1px",
        transition: "transform 0.2s"
      },
      "& > svg": {
        color: "#64748B",
      }
    },
    expandedArrow: {
      transform: "rotate(180deg)"
    },
    iconButtonWrapper: {
      marginBottom: "3px",
      "& img": {
        height: "42px"
      }
    },
    pollContainer:{
      marginRight: "350px",
      [theme.breakpoints.down(950)]: {
        marginRight: "0",
      },
    },
    commentImagePreviewWrapper: {
      position: "relative",
      margin: "5px 10px",
      height: "50px",
      width: "50px",
      "& > button": {
        position: "absolute",
        top: "-9px",
        right: "-8px",
        backgroundColor: "#ffca29",
        padding: "1px",
        "&:hover": {
          backgroundColor: "#ffca29"
        },
        "& svg": {
          fontSize: "1.1rem",
          color: "#000"
        }
      }
    },
    commentImagePreview: {
      height: "100%",
      width: "100%",
      borderRadius: "8px",
      marginTop: "3px",
      cursor: "pointer"
    },
    commentOptionsModalBox: {
      backgroundColor: "#fff",
      padding: "8px",
      borderRadius: "12px",
      minWidth: "240px",
      outline: "none",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    },
    uploadVideoCommentButton: {
      backgroundColor: "#000",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 16px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      minHeight: "44px", // Minimum touch target size for mobile
      touchAction: "manipulation", // Improve touch responsiveness
      WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
      "&:hover": {
        backgroundColor: "#333",
      },
      "&:active": {
        backgroundColor: "#555",
      },
    },
    addPollCommentButton: {
      backgroundColor: "transparent",
      color: "#64748B",
      border: "none",
      borderRadius: "8px",
      padding: "12px 16px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      minHeight: "44px", // Minimum touch target size for mobile
      touchAction: "manipulation", // Improve touch responsiveness
      WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
      "&:hover": {
        backgroundColor: "#f3f4f6",
      },
      "&:active": {
        backgroundColor: "#e5e7eb",
      },
    },
    pollCommentModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "24px",
      width: "100%",
      maxWidth: "500px",
      outline: "none",
      maxHeight: "90vh",
      overflowY: "auto",
    },
    pollCommentModalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    pollCommentModalTitle: {
      fontFamily: "Inter",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "28px",
      color: "#0F172A",
    },
    pollCommentModalCloseButton: {
      padding: "4px",
    },
    pollCommentModalSection: {
      marginBottom: "24px",
    },
    pollCommentModalLabel: {
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#0F172A",
      marginBottom: "8px",
      display: "block",
    },
    pollCommentModalInput: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        backgroundColor: "#F8FAFC",
        "& fieldset": {
          borderColor: "#E2E8F0",
        },
        "&:hover fieldset": {
          borderColor: "#CBD5E1",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#94A3B8",
        },
      },
      "& .MuiInputBase-input": {
        padding: "12px 16px",
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        color: "#0F172A",
        WebkitAppearance: "none",
        WebkitUserSelect: "text",
        userSelect: "text",
        "&::placeholder": {
          color: "#94A3B8",
          opacity: 1,
        },
        // Mobile-specific fixes to ensure inputs work properly
        [theme.breakpoints.down("sm")]: {
          fontSize: "16px", // Prevent zoom on iOS (minimum 16px)
          WebkitAppearance: "none",
          WebkitTapHighlightColor: "transparent",
          touchAction: "manipulation",
        },
      },
      // Ensure inputs are focusable on mobile
      "& .MuiInputBase-root": {
        [theme.breakpoints.down("sm")]: {
          WebkitTapHighlightColor: "transparent",
          touchAction: "manipulation",
        },
      },
    },
    pollCommentToggleLabel: {
      margin: 0,
      "& .MuiFormControlLabel-label": {
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        color: "#0F172A",
      },
    },
    pollCommentSwitch: {
      "& .MuiSwitch-switchBase": {
        "&.Mui-checked": {
          color: "#FFC629",
          "& + .MuiSwitch-track": {
            backgroundColor: "#FFC629",
          },
        },
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#E2E8F0",
      },
    },
    pollCommentModalFooter: {
      marginTop: "24px",
    },
    pollCommentContinueButton: {
      backgroundColor: "#000",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 24px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      cursor: "pointer",
      width: "100%",
      textAlign: "center",
      "&:hover": {
        backgroundColor: "#333",
      },
    },
    placeholder: {
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
      color: "#64748B",
      border: "1px red"
    },
    postCommentTextField: {
      "& .MuiOutlinedInput-root": {
        minHeight: "40px",
        maxHeight: "120px",
        "& textarea": {
          minHeight: "40px !important",
          maxHeight: "100px",
          overflowY: "auto !important",
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E2E8F0",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #000"
      },
      borderRadius: "0px 16px 16px 16px",
      backgroundColor: "#F8FAFC",
      borderColor: "#F0F3F8",
    },

    postCommentinput: {
      "&::placeholder": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: 400,
        fontStyle: "normal",
        color: "#64748B",
      },
    },
  })
export const OpenNotificationWeb = withWidth()(withStyles(styles)(OpenNotification));
// Customizable Area End
